export const SCREEN_WIDTH = parseFloat(window.screen.width)
